import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const DinoIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			d="M11.5026 1.44888C11.5282 1.19675 11.7411 1 12 1H13C13.2761 1 13.5 1.22386 13.5 1.5V2.5H14.5C14.7761 2.5 15 2.72386 15 3V3.5C15 3.77614 14.7761 4 14.5 4H13V14.5C13 14.7761 12.7761 15 12.5 15H12C11.7239 15 11.5 14.7761 11.5 14.5V12.5H10.5V14.5C10.5 14.7761 10.2761 15 10 15H9.5C9.22386 15 9 14.7761 9 14.5V12.5H8V14.5C8 14.7761 7.77614 15 7.5 15H7C6.72386 15 6.5 14.7761 6.5 14.5V12.5H5.5V14.5C5.5 14.7761 5.27614 15 5 15H1.5C1.22386 15 1 14.7761 1 14.5V12.5C1 12.2239 1.22386 12 1.5 12H2C2.27614 12 2.5 12.2239 2.5 12.5V13.5H4V11.5C4 11.2239 4.22386 11 4.5 11H5.5V10C5.5 9.72386 5.72386 9.5 6 9.5H7V8.5C7 8.22386 7.22386 8 7.5 8H11.5V1.5C11.5 1.48274 11.5009 1.46569 11.5026 1.44888Z"
		></path>
	</svg>
))
